<div class="rn-page">

  <h3 class="rn-page__heading">
    <span>All Jobs</span>
    @if (appliedFilters.length >= 1) {
      <span>results for <strong>"{{displayableFilters()}}"</strong></span>
    }
    @if (appliedSort) {
      <span> sorted by <strong>{{appliedSort | titleText}}</strong></span>
    }
  </h3>
  <div class="rn-page__utility">
    <rn-search-input (searchTerm)="searchChanged($event)"></rn-search-input>
    <rn-select id="sort-select" [selectedOption]="appliedSort" [options]="sortOptions" [labelText]="'Sort by'" [placeholderText]="'Select Sort'" (selectChanged)="sortSelectChanged($event)"></rn-select>
    <div>
      <rn-select #filetypeSelect id="type-filter-select" [name]="'filetype'" [options]="fileTypes" [labelText]="'Filter by'" [placeholderText]="'Filter By Type'" (selectChanged)="filterChanged($event)"></rn-select>
      <rn-select #statusSelect id="status-filter-select" [name]="'status'" [options]="statusFilterOptions" [placeholderText]="'Filter By Status'" (selectChanged)="filterChanged($event)"></rn-select>
    </div>
  </div>
  <div class="rn-page__sub-utility">
    <rn-tag-filter-list [colorPresets]="jobsListStatusColorMap" [appliedFilters]="appliedFilters" (filterRemoved)="filterRemoved($event)" (filtersCleared)="clearFilters()"></rn-tag-filter-list>
    <button [ngClass]="{'btn-refresh': true, 'btn-refresh--loading': jobsLoading }" (click)="refreshJobsClicked()">
      <i aria-hidden="true" class="fa fa-refresh"></i>
      {{jobsLoading ? 'Loading' : 'Refresh List'}}
    </button>
  </div>
  <div class="rn-list">
    <ul class="rn-list__row rn-list__row--header">
      <li class="rn-list__col">
        <span class="rn-list__heading-1" (click)="sortChanged('status')">
          Status
          @if (appliedSort === 'status' && sortDirection === 'desc') {
            <i class='fa fa-caret-down'></i>
          }
          @if (appliedSort === 'status' && sortDirection === 'asc') {
            <i class='fa fa-caret-up'></i>
          }
        </span>
      </li>
      <li class="rn-list__col rn-list__col--wide jobs-list__filename-col">
        <span class="rn-list__heading-1" (click)="sortChanged('filename')">
          File Name
          @if (appliedSort === 'filename' && sortDirection === 'desc') {
            <i class='fa fa-caret-down'></i>
          }
          @if (appliedSort === 'filename' && sortDirection === 'asc') {
            <i class='fa fa-caret-up'></i>
          }
        </span>
      </li>
      <li class="rn-list__col rn-list__col--spacer"></li>
      <li class="rn-list__col">
        <span class="rn-list__heading-1" (click)="sortChanged('filetype')">
          File Type
          @if (appliedSort === 'filetype' && sortDirection === 'desc') {
            <i class='fa fa-caret-down'></i>
          }
          @if (appliedSort === 'filetype' && sortDirection === 'asc') {
            <i class='fa fa-caret-up'></i>
          }
        </span>
      </li>
      <li class="rn-list__col">
        <span class="rn-list__heading-1" (click)="sortChanged('last_modified_at')">
          Modified At
          @if (appliedSort === 'last_modified_at' && sortDirection === 'desc') {
            <i class='fa fa-caret-down'></i>
          }
          @if (appliedSort === 'last_modified_at' && sortDirection === 'asc') {
            <i class='fa fa-caret-up'></i>
          }
        </span>
      </li>
      <li class="rn-list__col">
        <span class="rn-list__heading-1" (click)="sortChanged('job_started_at')">
          Started At
          @if (appliedSort === 'job_started_at' && sortDirection === 'desc') {
            <i class='fa fa-caret-down'></i>
          }
          @if (appliedSort === 'job_started_at' && sortDirection === 'asc') {
            <i class='fa fa-caret-up'></i>
          }
        </span>
      </li>
    </ul>

    @if (noJobsForClient() && !jobsError()) {
      <div>
        This client has no File Engine jobs@if (appliedFilters.length > 0) {
        <span> matching these filters</span>
        }.
      </div>
    }

    @if (jobsError()) {
      <div>
        There was an error loading Jobs for this client.
      </div>
    }

    @for (job of jobs$ | async; track jobTrackbyKey($index, job)) {
      <div>
        <rn-list-item-expandable>
          <div expandable-item>
            <ul class="rn-list__row">
              <li class="rn-list__col">
                <rn-status [status]="job.status"></rn-status>
              </li>
              <li class="rn-list__col rn-list__col--wide jobs-list__filename-col" [attr.title]="job.filename">{{job.filename}}</li>
              <li class="rn-list__col rn-list__col--spacer"></li>
              <li class="rn-list__col">{{job.filetype.replace('journey', 'experience') | titleText}}</li>
              <li class="rn-list__col">{{jobTimestampText(job, 'last_modified_at')}}</li>
              <li class="rn-list__col">{{jobTimestampText(job, 'job_started_at')}}</li>
            </ul>
          </div>
          <rn-jobs-list-detail expandable-detail [job]="job"
            [showCancel]="jobCanBeCancelled(job)" (cancelClicked)="showCancelJobWarning($event)"
          [showSchedule]="jobCanBeScheduled(job)" (scheduleClicked)="openScheduleDialog($event)"></rn-jobs-list-detail>
        </rn-list-item-expandable>
      </div>
    }
  </div>
</div>

<message-dialog #cancelJobDialog [showCancel]="true" [affirmButtonText]="'yes'" [cancelButtonText]="'no'" (affirm)="cancelJob($event)"></message-dialog>
<message-dialog #messageDialog></message-dialog>

<!-- using ngif out here instead of in the component -->
@if (scheduleTime) {
  <schedule-launch-dialog
    [showDialog]="true"
    [thingBeingLaunched]="'file'"
    [(scheduleTime)]="scheduleTime"
    (confirmTime)="scheduleFile($event)"
    (showDialogChange)="closeScheduleDialog()">
    <ng-container schedule-button-content>
      <span class="btn-label">Schedule</span>
      <span class="icon icon-right"><i aria-hidden="true" class="fa fa-history"></i></span>
    </ng-container>
  </schedule-launch-dialog>
}

<message-dialog #progressDialog>
  <app-spinner></app-spinner>
</message-dialog>
